import React from "react";
import { Link } from "react-router-dom";

import "../SignupPages/SignupCommon.css";
import "../SignupPages/Signup6.css";
import PageWrapper from "../SignupPages/PageWrapper";
const DisqualifyStateNadPlusPage: React.FC = () => {
    return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="signup-content">
          <div className="error-container">
            <div className="error-box">
              <h1 className="error-condition">
              Sorry for the inconvenience.
              </h1>
            </div>
            <span className="error-content">It appears that the NAD+ Nasal Spray is not available in your state. You can go back and select NAD+ injection to proceed further.</span>
            
            <Link to="/nadplus/getting-started/step-12">
              <button className="next-btn">SELECT NAD+ INJECTION</button>
            </Link>
          </div>
          <div style={{ paddingTop: "20px"}}>
            <span className="suffix-text-error">If you believe this is an error, please dont hesitate to contact us at <span className="suffix-support-email">support@claya.com</span> for assistance.</span>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default DisqualifyStateNadPlusPage;